import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect, useSelector } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
// import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility';

// import avatar from "../../assets/images/companies/img-4.png"
import Table from './Table';
import Breadcrumb from "../../components/Common/Breadcrumb";
import Loader from "../../components/Loader";

const ImageStore = props => {
  const { user } = props;
  const [loading, setLoading] = useState(false);

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Image Store" />
        {/* <Header /> */}
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        {/* <Breadcrumb title={Utils.projectName} breadcrumbItem="Image Store" /> */}
        {/* <Card>
          <CardBody> */}
        <Table
          role={"Images"}
          user={user}
          setLoading={setLoading}
        />
        {/* </CardBody>
        </Card> */}
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, { })(ImageStore)
)
